import React, { useContext } from 'react';
import { each, isEmpty } from 'underscore';
import PropTypes from 'prop-types';
import { useSiteConfig, DataServiceContext } from '@bingads-webui-campaign-react/smart-page-context';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  componentsConfig,
  getPageIndexById,
  getComponentById,
  getPilotValue,
  getWebsiteSourceDataByKey,
} from '@bingads-webui-campaign-react/smart-component-util';
import { proxyReadLogoConfig } from '@bingads-webui-campaign-react/smart-component-image';
import { SmartHeaderView } from './smart-header-view';
import { useActionButtons } from './components/use-action-buttons';

export const SmartHeaderConnector = ({
  id,
  rootId,
  disabled,
  footerSplit,
}) => {
  const i18n = useContext(I18nContext);
  const serverContext = useContext(DataServiceContext);
  const { siteConfig } = useSiteConfig();
  const {
    imageId: logoImageId,
    label: logoName,
  } = proxyReadLogoConfig({ i18n, siteConfig });
  const actionButtons = useActionButtons();

  const items = [];
  let hasOptional = false;
  const pageIndex = getPageIndexById(siteConfig, rootId);

  each(siteConfig.orderedComponentsInPages && siteConfig.orderedComponentsInPages[pageIndex], ({
    type,
    id: componentId,
  }) => {
    const {
      navTitle,
      required,
      hideNavWhenEmpty,
      dataProp,
      pilot,
      wsdKey,
    } = componentsConfig[type] || {};
    const isPilotOn = pilot ? getPilotValue(serverContext, pilot) : true;

    if (navTitle) {
      let isVisible = false;

      if (!hideNavWhenEmpty) {
        isVisible = true;
      } else {
        const compConfig = getComponentById(siteConfig, componentId);

        if (compConfig) {
          let wsdConfig;
          if (wsdKey) {
            wsdConfig = getWebsiteSourceDataByKey(siteConfig, wsdKey);
          }

          if (
            (compConfig[dataProp] && !isEmpty(compConfig[dataProp]))
            || (wsdConfig && !isEmpty(wsdConfig))
          ) {
            isVisible = true;
          }
        }
      }

      // Hide navigation when the component related pilot is off
      // even if the component config exists.
      if (!isPilotOn) {
        isVisible = false;
      }

      if (isVisible) {
        items.push({
          title: i18n.getString(navTitle),
          targetId: componentId,
        });
        hasOptional = hasOptional || !required;
      }
    }
  });

  return (
    <SmartHeaderView
      id={id}
      logoImageId={logoImageId}
      logoName={logoName}
      items={items}
      showItems={hasOptional}
      actionButtons={actionButtons}
      disabled={disabled}
      footerSplit={footerSplit}
    />
  );
};

SmartHeaderConnector.propTypes = {
  id: PropTypes.string.isRequired,
  rootId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  footerSplit: PropTypes.bool,
};

SmartHeaderConnector.defaultProps = {
  disabled: false,
  footerSplit: false,
};
